import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import State from '../states'
import MessageDialogue, { Props } from '../components/MessageDialogue'

class TogglableDialogue extends React.Component<Props & { show: boolean }> {
  render () {
    const { show, ...props } = this.props
    return show ? <MessageDialogue {...props} /> : null
  }
}

const mapStateToProps = (state: State): Partial<Props & { show: boolean }> => ({
  show: state.ui.showDialogue,
  messages: state.world.messages
})

const mapDispatchToProps = (_dispatch: Dispatch<State>): Partial<Props> => ({})

export default connect(mapStateToProps, mapDispatchToProps)(TogglableDialogue)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Dialogue.tsx